package music.jammers.shared.user.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class UserProfileUpdateData(
    val userName: String,
    val telegram: String,
    val city: String
)